/**
 * Formats a number of bytes into a human-readable string.
 * @param bytes The number of bytes to format.
 * @returns A string representing the formatted bytes.
 */
export function formatBytesLocal(bytes?: number) {
  if (!bytes && bytes !== 0) return '-';
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let i = -1;
  let val = bytes;
  do {
    val /= 1024;
    i++;
  } while (val >= 1024 && i < units.length - 1);
  return `${val.toFixed(1)} ${units[i]}`;
}
